// @core/api/endpoints/context/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.
import { GetContextLayout } from './get_context_layout';
import { GetTenantContextConfig } from './get_tenant_context_config';
import { GetUserContextPreferences } from './get_user_context_preferences';
import { ListManifests } from './list_manifests';
import { RegisterAspectManifest } from './register_aspect_manifest';
import { RegisterRelationGroupManifest } from './register_relation_group_manifest';
import { TrackBehavior } from './track_behavior';
import { UpdateTenantContextConfig } from './update_tenant_context_config';
import { UpdateUserContextPreferences } from './update_user_context_preferences';

// Re-export individual endpoints
export {
  GetContextLayout,
  GetTenantContextConfig,
  GetUserContextPreferences,
  ListManifests,
  RegisterAspectManifest,
  RegisterRelationGroupManifest,
  TrackBehavior,
  UpdateTenantContextConfig,
  UpdateUserContextPreferences,
};

// Namespace export for convenient usage
export const contextApi = {
  GetContextLayout,
  GetTenantContextConfig,
  GetUserContextPreferences,
  ListManifests,
  RegisterAspectManifest,
  RegisterRelationGroupManifest,
  TrackBehavior,
  UpdateTenantContextConfig,
  UpdateUserContextPreferences,
};
